import gsap from "gsap";

export default class Magnetic {
    constructor(el, options = {}) {
        this.el = typeof el === 'string' ? document.querySelector(el) : el;
        
        // Get data-magnetic attribute if exists
        const dataOptions = this.el.dataset.magnetic ? JSON.parse(this.el.dataset.magnetic) : {};
        
        this.options = {
            y: 0.2,
            x: 0.2,
            s: 0.2,
            rs: 0.7,
            ...dataOptions,
            ...options
        };

        this.y = 0;
        this.x = 0;
        this.width = 0;
        this.height = 0;

        if (this.el.dataset.magneticInit) return;
        this.el.dataset.magneticInit = 'true';

        this.bind();
    }

    bind() {
        this.el.addEventListener('mouseenter', () => {
            const rect = this.el.getBoundingClientRect();
            this.y = rect.top;
            this.x = rect.left;
            this.width = this.el.offsetWidth;
            this.height = this.el.offsetHeight;
        });

        this.el.addEventListener('mousemove', (e) => {
            const y = (e.clientY - this.y - this.height / 2) * this.options.y;
            const x = (e.clientX - this.x - this.width / 2) * this.options.x;

            this.move(x, y, this.options.s);
        });

        this.el.addEventListener('mouseleave', (e) => {
            this.move(0, 0, this.options.rs);
        });
    }

    move(x, y, speed) {
        gsap.to(this.el, {
            y: y,
            x: x,
            force3D: true,
            overwrite: true,
            duration: speed
        });
    }
}
